import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { money, perWatt, num } from "@/lib/format";
import { Lock, ArrowLeft } from "lucide-react";

export default function VersionView({ snapshot, activeLabel, onBackToCurrent }) {
  const t = snapshot?.totals || {};
  const lines = snapshot?.scope_lines || [];
  const total = t.total != null ? t.total : snapshot?.total;
  const ppw = t.cost_per_watt != null ? t.cost_per_watt : snapshot?.cost_per_watt;
  return (
    <div className="p-6 max-w-[1800px] w-full mx-auto" data-testid="version-view">
      <div className="shrink-0 -mx-6 -mt-6 mb-5 bg-slate-900 text-white text-xs px-6 py-2.5 flex items-center gap-2" data-testid="version-view-banner">
        <Lock className="w-3.5 h-3.5" />
        Viewing <b className="mx-1">{snapshot?.label}</b> — a locked {(snapshot?.type || "revision").replace("_", " ")}. Switch to {activeLabel} to make edits.
      </div>
      <div className="flex items-center justify-between mb-4">
        <div className="font-display text-xl font-bold text-black">{snapshot?.label}</div>
        <Button variant="outline" size="sm" data-testid="version-back-current" onClick={onBackToCurrent}>
          <ArrowLeft className="w-4 h-4 mr-1.5" /> Back to {activeLabel}
        </Button>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-5">
        <Card className="p-4"><div className="text-[11px] uppercase tracking-wide text-slate-400">Total</div><div className="font-display text-2xl font-bold text-black">{total != null ? money(total) : "—"}</div></Card>
        <Card className="p-4"><div className="text-[11px] uppercase tracking-wide text-slate-400">$/W</div><div className="font-display text-2xl font-bold text-black">{ppw != null ? perWatt(ppw) : "—"}</div></Card>
      </div>
      <div className="rounded-lg border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-xs">
            <tr><th className="text-left px-3 py-2 font-medium">Scope line</th><th className="text-right px-3 py-2 font-medium">Qty</th><th className="text-left px-3 py-2 font-medium">Unit</th></tr>
          </thead>
          <tbody>
            {lines.length === 0 && <tr><td colSpan={3} className="px-3 py-6 text-center text-slate-400">No scope lines captured in this version.</td></tr>}
            {lines.map((l, i) => (
              <tr key={i} className="border-t border-slate-100" data-testid={`version-line-${i}`} data-line-id={l.line_id || l.id || l.name}>
                <td className="px-3 py-2 text-slate-700">{l.name || l.description || l.task_type_name || l.task_type || `Line ${i + 1}`}</td>
                <td className="px-3 py-2 text-right font-mono text-slate-600">{l.quantity != null ? num(l.quantity) : "—"}</td>
                <td className="px-3 py-2 text-slate-500">{l.unit || ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
